import { useEffect } from "react";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { MESSAGE } from '../../utils/message';
import {
  FooterWrapper,
  FooterText,
  LinkHeading,
  LinkList,
  LinkItem,
  TopFooter,
  BottomFooter,
  CopyRightFooter,
  FooterLogoImage,
  TopBottombtn,
} from './footerStyle';
import FooterLogo from '../../assests/images/gnp_logo.svg';
import BlackSms from '../../assests/images/black-sms.svg';
import Black_Call_Icon from '../../assests/images/balck-call-incoming.svg';
import FacebookIcon from '../../assests/images/black-facebook.svg';
import TwitterIcon from "../../assests/images/xicon.svg";
import InstagramIcon from "../../assests/images/black-instagram.svg";
import Linkedin_Icon from "../../assests/images/black-linkedin-in.svg";
import TopIcon from "../../assests/images/arrow-down-white.svg";
import { useDispatch, useSelector } from "react-redux";
import { citiesHandler } from '../../redux/slices/donationCamp/cities-slice';
import { topCausesHandler } from '../../redux/slices/donationCamp/topCauses-slice';
import { URLs } from "../../utils/constant";

const Footer = () => {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const topCausesData: any = useSelector((state: any) => state?.topCauses?.data?.results);
  const footerCities: any = useSelector((state: any) => state?.footerCities?.data?.results);
  const currentYear = new Date().getFullYear();
  useEffect(() => {
    dispatch(topCausesHandler());
    dispatch(citiesHandler());
  }, [])


  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <FooterWrapper>
        <Container className="cont-w">
          <TopFooter>
            <Row>
              <Col lg={4} sm={12} md={5}>
                <FooterLogoImage><Image src={FooterLogo} /></FooterLogoImage>
                <FooterText>{MESSAGE.footerText} </FooterText>
                <a href="/org/greatnonprofits" className="write-yellow-btn footer-org-btn">
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
                    <g id="Group" transform="translate(11.083 8.75)">
                      <path id="Vector" d="M0,6.137A2,2,0,0,0,1.948,8.178H4.142A1.737,1.737,0,0,0,5.833,6.393,1.541,1.541,0,0,0,4.678,4.7L1.167,3.477A1.533,1.533,0,0,1,.012,1.785,1.745,1.745,0,0,1,1.7,0H3.9A2,2,0,0,1,5.845,2.042" transform="translate(0 1.155)" fill="none" stroke="#333" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.6" />
                      <path id="Vector-2" data-name="Vector" d="M0,0V10.5" transform="translate(2.917)" fill="none" stroke="#333" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.6" />
                    </g>
                    <path id="Vector-3" data-name="Vector" d="M23.333,11.667A11.667,11.667,0,1,1,11.667,0" transform="translate(2.333 2.333)" fill="none" stroke="#333" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.6" />
                    <path id="Vector-4" data-name="Vector" d="M0,0V4.667H4.667" transform="translate(19.833 3.5)" fill="none" stroke="#333" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.6" />
                    <path id="Vector-5" data-name="Vector" d="M5.833,0,0,5.833" transform="translate(19.833 2.333)" fill="none" stroke="#333" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.6" />
                    <path id="Vector-6" data-name="Vector" d="M0,0H28V28H0Z" fill="none" opacity="0" />
                  </svg>

                  {MESSAGE.donateGreatNonprofits}</a>
              </Col>
              <Col lg={8} sm={12} md={7} className='right-col'>
                <Row>
                  <Col lg={4} sm={12} md={6}>
                    <LinkHeading>{MESSAGE.quickLinks}</LinkHeading>
                    <LinkList>
                      <LinkItem><a href={`${import.meta.env.VITE_CMS_URL}`}>{MESSAGE.aboutUs} </a></LinkItem>
                      <LinkItem><a href={`${import.meta.env.VITE_CMS_URL}about/careers/`}>{MESSAGE.careers}</a> </LinkItem>
                      <LinkItem><a href="/contact-us/">{MESSAGE.contactFaqs}</a></LinkItem>
                      <LinkItem><a href={`${import.meta.env.VITE_CMS_URL}about/press/`}>{MESSAGE.press}</a></LinkItem>
                      <LinkItem><a href="https://communityconnectlabs.com/" >{MESSAGE.communityConnect}</a></LinkItem>
                    </LinkList>
                  </Col>
                  <Col lg={4} sm={12} md={6}>
                    <LinkHeading>{MESSAGE.forNonprofits}</LinkHeading>
                    <LinkList>

                      <LinkItem><a href={`${import.meta.env.VITE_CMS_URL}about/claim-your-nonprofit/`}>{MESSAGE.claimYourNonprofit}</a></LinkItem>
                      <LinkItem><a href={`${import.meta.env.VITE_CMS_URL}about/get-donations/`}>{MESSAGE.Donations}</a></LinkItem>
                      <LinkItem><a href={`${import.meta.env.VITE_CMS_URL}about/invite-reviews/`}>{MESSAGE.inviteReviews}</a></LinkItem>
                      <LinkItem><a href={`${import.meta.env.VITE_CMS_URL}toprated/about-top-rated-awards/`}>{MESSAGE.topRatedAwards}</a></LinkItem>
                      <LinkItem><a href={`${import.meta.env.VITE_CMS_URL}about/great-nonprofit-badge/`}>{MESSAGE.topRatedBadge}</a></LinkItem>
                    </LinkList>
                  </Col>
                  <Col lg={4} sm={12} md={6}>
                    <LinkHeading>{MESSAGE.connectWithUs}</LinkHeading>
                    <LinkList>
                      <LinkItem>
                        <Link to={`mailto:${URLs.mail}`}><span><Image src={BlackSms} /></span>{URLs.mail}</Link>
                      </LinkItem>
                      <LinkItem>
                        <Link to={`tel:${URLs?.phone}`}><span><Image src={Black_Call_Icon} /></span>{URLs.phone}</Link>
                      </LinkItem>
                      <LinkItem>
                        <Link to={URLs.facebook} target="_blank" title='Facebook'><span><Image src={FacebookIcon} /></span></Link>
                        <Link to={URLs.xURL} target="_blank" title='X'><span><Image src={TwitterIcon} /></span></Link>
                        <Link to={URLs.instagram} target="_blank" title='Instagram'><span><Image src={InstagramIcon} /></span></Link>
                        <Link to={URLs.linkedin} target="_blank" title='Linkedin'><span><Image src={Linkedin_Icon} /></span></Link>
                      </LinkItem>
                    </LinkList>
                  </Col>
                </Row>
              </Col>
            </Row>
          </TopFooter>
          <BottomFooter>
            <Row>
              <Col md={6}>
                <LinkHeading>{MESSAGE.topCities}</LinkHeading>
                <LinkList>
                  {footerCities?.slice(0, 14)?.map((city: any, index: number) => (<LinkItem key={index + 1}><Button onClick={() => navigate(`/city/${city?.slug}/${city?.state}`)}>{city?.city}</Button></LinkItem>))}
                  <LinkItem ><a href={import.meta.env.VITE_CMS_URL + "about/top-cities/"} referrerPolicy="no-referrer" className='more-city'>{MESSAGE.moreCities}</a></LinkItem>
                </LinkList>
              </Col>
              <Col md={6}>
                <LinkHeading>{MESSAGE.topCauses}</LinkHeading>
                <LinkList>
                  {topCausesData?.slice(0, 14)?.map((topCause: any, index: number) => (<LinkItem key={index + 1}><Button onClick={() => navigate(`/categories/view/${topCause?.category?.slug}`)}>{topCause?.category?.name}</Button></LinkItem>))}
                  {topCausesData?.length && <LinkItem><a href={import.meta.env.VITE_CMS_URL + "about/top-causes/"} referrerPolicy="no-referrer" className='more-city'>{MESSAGE.moreCauses}</a></LinkItem>}
                </LinkList>
              </Col>
            </Row>
          </BottomFooter>

        </Container>

      </FooterWrapper>
      <CopyRightFooter>
        {MESSAGE.versionText(currentYear)} EIN 68-0224596 <a href="https://new.greatnonprofits.org/pages/terms-of-service/" rel="noreferrer">{MESSAGE.terms}</a> and <a href="https://new.greatnonprofits.org/pages/privacy-policy/" rel="noreferrer" >{MESSAGE.privacy}</a>.
      </CopyRightFooter>
      <TopBottombtn id="button" onClick={scrollToTop}>
        <Image src={TopIcon} />
      </TopBottombtn>
    </>
  )
}

export default Footer 
